module.exports = __webpack_public_path__ + "static/media/unico-materiais-construcao.e8133eb3.webp";